import Countdown, { calcTimeDelta, zeroPad } from 'react-countdown'
import { useTranslation } from 'react-i18next'
import { ClockIcon } from '../icons/AuctionIcons'
import { formatToLocalDate } from '../../../app/helpers'

interface Props {
  startDate: Date
  endDate: Date
  bidding?: boolean
}

function AuctionCountDown({ startDate, endDate, bidding = false }: Props) {
  const { t, i18n } = useTranslation()
  const formattedStartDate = formatToLocalDate(startDate, i18n.language)

  const renderer = ({ days, hours, minutes, seconds, completed }: any) => {
    if (new Date() < new Date(startDate)) {
      return (
        <div className={`d-flex flex-wrap ${!bidding && 'flex-column'}`}>
          <p>{t('auction_starts_on')}:</p>
          <p className="ps-2">{formattedStartDate}</p>
        </div>
      )
    }
    if (completed) {
      return (
        <div className="d-flex align-items-center">
          <ClockIcon />
          <p className="ms-2 mb-0">{t('finished')}</p>
        </div>
      )
    }
    return (
      <>
        {!bidding ? (
          <div className="d-flex align-items-center">
            <ClockIcon />
            <p className="auction-countdown">
              {zeroPad(days)}d {zeroPad(hours)}h {zeroPad(minutes)}min{' '}
              {zeroPad(seconds)}sec
            </p>
          </div>
        ) : (
          <div className="bidding-countdown text-center d-flex flex-wrap justify-content-center align-itmes-center">
            <div className="d-flex align-items-end">
              <h4>{zeroPad(days)}</h4>
              <p>{t('days')}</p>
            </div>
            <h3 className="ps-2 pe-2"> : </h3>
            <div className="d-flex align-items-end">
              <h4>{zeroPad(hours)}</h4>
              <p>{t('hours')}</p>
            </div>
            <h3 className="ps-2 pe-2"> : </h3>
            <div className="d-flex align-items-end">
              <h4>{zeroPad(minutes)}</h4>
              <p>{t('minutes')}</p>
            </div>
            <h3 className="ps-2 pe-2"> : </h3>
            <div className="d-flex align-items-end">
              <h4>{zeroPad(seconds)}</h4>
              <p>{t('seconds')}</p>
            </div>
          </div>
        )}
      </>
    )
  }

  calcTimeDelta(endDate, { now: Date.now })

  return <Countdown date={endDate} renderer={renderer} />
}
export default AuctionCountDown
